export enum ServiceTypes {
  glasses = 'Glasses',
  exam = 'ExamOnly',
  contacts ='Contacts'
}

export enum OffersEligibilityTypes {
  withOffers = 'SpecialOffer',
  withoutOffers = 'NoSpecialOffer'
}

export enum BenefitsTiers {
  plusProvider = 'PLUS',
  nonPlusProvider = 'NonPLUS'
}

export enum FinalPageIds {
  EstimatedCosts = 'estimated_cost',
  MemberDiscounts = 'member_discount',
  PriceComparison = 'price_comparison',
  DiscountsSection = 'moresavings',
  OffersSection = 'special_offers',
  AppointmentForm = 'appointment_maker',
  BottomSummaryPP = 'bottom_summary_pp',
}
